exports.getCallback = function (options, callback) {
  return typeof options === 'function' ? options : callback
}

exports.getOptions = function (options) {
  return typeof options === 'object' && options !== null ? options : {}
}



//////////////////
// WEBPACK FOOTER
// ./~/ganache-core/~/levelup/lib/common.js
// module id = 257
// module chunks = 0 1 2